var styleDataHash = "05f6a707";
const injectCss = (() => {
  var css = `.tTOQj{height:18px;position:relative;width:18px}.SIfeW,._5L8d0{height:100%;left:0;position:absolute;top:0;width:100%;fill:none;stroke-linecap:round}._5L8d0{animation:U7J11 666ms linear infinite;opacity:.3}.SIfeW,._5L8d0{stroke:currentColor}.SIfeW{animation:U7J11 2s linear infinite}@keyframes U7J11{to{transform:rotate(1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var double_loader_default = {
  "wrapper": "tTOQj",
  "top": "_5L8d0",
  "bottom": "SIfeW",
  "rotation": "U7J11"
};
export {
  double_loader_default as default,
  injectCss
};
//# sourceMappingURL=double-loader-scss.js.map
